export type ComparisonRow = { criterion: string; cells: string[] };

export function ComparisonTable({
  columns,
  rows,
  caption,
}: {
  columns: string[];
  rows: ComparisonRow[];
  caption?: string;
}) {
  return (
    <div className="overflow-x-auto border border-[var(--rule)] rounded-sm bg-[var(--paper)]">
      {caption && (
        <div className="px-4 py-3 border-b border-[var(--rule)] text-sm text-[var(--ink)]/70">{caption}</div>
      )}
      <table className="w-full text-sm">
        <thead className="bg-[var(--sand-soft)] text-[var(--ink)]">
          <tr>
            <th className="text-left font-display font-medium px-4 py-3 border-b border-[var(--rule)]">Kriterium</th>
            {columns.map((c) => (
              <th key={c} className="text-left font-display font-medium px-4 py-3 border-b border-[var(--rule)]">
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="odd:bg-[var(--paper)] even:bg-[var(--cloud)]">
              <td className="px-4 py-3 border-b border-[var(--rule)] text-[var(--ink)] font-medium">{r.criterion}</td>
              {r.cells.map((c, j) => (
                <td key={j} className="px-4 py-3 border-b border-[var(--rule)] text-[var(--ink)]/80">
                  {c}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
